import NotificationBell from "../common/NotificationBell";
import DjStatusPanel from "./DjStatusPanel";
import { useWebSocketContext } from "../../context/WebSocketProvider";
import { useDjContext } from "../../context/DjContext";

function DjHeader({ djId }) {
  useWebSocketContext();
  const { isOnline, place, price } = useDjContext();

  return (
    <header className="text-textMain p-4 flex flex-row justify-between items-center dj-header">
      <h1 className="text-xl font-bold">DJ Panel</h1>

      {isOnline && (
        <div className="hidden md:block text-center">
          {place} | {price} PLN
        </div>
      )}

      <div className="flex items-center gap-4">
        <NotificationBell userId={djId} />
        <DjStatusPanel />
      </div>
    </header>
  );
}

export default DjHeader;
